import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { getAllVerticals, updateVertical } from '../../config/services/commercialService';
import { Button, Modal, FormControl, Form, Row, FormGroup, FormLabel } from 'react-bootstrap';
import Select from 'react-select';

const EditSparePartsModal = (props) => {
    const { showModal, hideModal, fetchSpareParts, sparePartsToEdit, pageNo} = props;
    const [model, setModel] = useState();
    const [verticleList, setVericleList] = useState("");
    const [spareName, setSpareName] = useState("");
    const [spareNameList, setSpareNameList] = useState(sparePartsToEdit.spares ? sparePartsToEdit.spares.map((eqp) => ({label:eqp.name, value:eqp._id})) : []);
    const [verticleID, setVerticleID] = useState(sparePartsToEdit.verticalName);
    useEffect(() => {
        fetchVerticle();
    }, []);

    const fetchVerticle = () => {
        getAllVerticals()
            .then(res => {
                const response = res.data;
                if (response.statusCode == 1) {
                    const data = response.responseData.result;
                    setVericleList(data)
                    let verticleData = []
                    data.map( (verticleDetails) => {
                        
                        let verticle= {
                          label:verticleDetails.verticalName,
                          value: verticleDetails._id
                        }
                        verticleData.push(verticle)
                    })
                    setVericleList(verticleData);
          
                  } else if (response.statusCode == 0) {
                    toast.error(response.error.errorMessage);
                  }
                })
                .catch((error) => {
                  console.log("error", error);
                });
          
    };

    const handleValidation = () => {
        if(model) {
            toast.error("Please select Model");
            return false;
        }

        return true;
    };

    const formSubmission = (event) => {
        event.preventDefault();
        const validationFlag = handleValidation();
        if(validationFlag) {
            let data = [];
            if(spareNameList){
            
                data = spareNameList.map(e => {
                
                    return{
                        name:e.label  
                    }
                })
            }
            const finalData = 
                {
                    
                    spares:JSON.stringify(data),
                    verticalId:sparePartsToEdit._id,
                    verticalName: verticleID
                };

            const params = finalData;
            updateVertical(params)
                .then(res => {
                    const response = res.data;

                    if (response.statusCode == 1) {
                        const data = response.responseData;
                        fetchSpareParts(pageNo);
                        toast.success(data.message);
                        hideModal();
                    } else if (response.statusCode == 0) {
                        toast.error(response.error.errorMessage)
                    }
                })
                .catch((error) => {
                    console.log('error', error);
                })
            }
    };

    return (
        <div className="main-wrapper">
            <Modal show={showModal} onHide={hideModal} centered size="xl" backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Edit Product Type</Modal.Title>
                </Modal.Header>

                <Modal.Body className="modal-body-height">
                    <Form onSubmit={(e) => formSubmission(e)}>
                        <div className='row' style={{marginTop: "30px"}}>
                            <FormGroup className='col-lg-6 col-xl-6'>
                                <FormLabel>Product Type</FormLabel>
                                <FormControl
                                    value={verticleID}
                                    name="verticleID"
                                    onChange={(e) => {setVerticleID(e.target.value)}}
                                    required
                                    type="text"
                                    placeholder="Spare Part Name"
                                />
                           
                            </FormGroup>

                            <FormGroup className='col-lg-6 col-xl-6'>
                                <FormLabel>Spare Parts</FormLabel>
                                <Select
                                    isMulti
                                    name="spareNameList"
                                    options={spareNameList}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    onChange={(e) => setSpareNameList(e)}
                                    value={spareNameList}
                                />
                            </FormGroup>
                        </div>

                        <Row className="justify-content-center" style={{marginTop: "30px"}}>
                            <Button variant="danger" onClick={hideModal}>Cancel</Button>
                            <Button className="ml-2" variant="success" type="submit">Submit</Button>
                        </Row>
                    </Form>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default EditSparePartsModal;